module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-sub-03@m.c95edac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-03@m.png
// module id = H88C
// module chunks = 0